import TabUnderlineLayout from '@/src/ui/tabs/components/UnderlinedTabLayout';
import {UnderlinedTabsProps} from '@/src/ui/tabs/containers/UnderlinedTabs';

import css from '../styles/TabUnderlineLayout.module.css';

const UnderlinedTabsLayout = ({
  tabsList,
  onClick,
}: UnderlinedTabsProps): JSX.Element => {
  return (
    <div className={css.tabListWrapper}>
      <div className={css.tabsList}>
        {tabsList.map((tab) => (
          <TabUnderlineLayout
            onClick={() => (tab.isActive ? null : onClick(tab.id))}
            text={tab.text}
            key={tab.id}
            isActive={tab.isActive}
          />
        ))}
      </div>
    </div>
  );
};

export default UnderlinedTabsLayout;
